<template>
	<V id="admin"/>
</template>
<script>
export default {  };
</script>
